{"errno":-2,"code":"ENOENT","syscall":"open","path":"/tmp/tmp-255562YwzyVB4lTNJ0/packages/auth/dist/[synthetic:util/defineproperty]"}